import React from 'react';
import { Language } from '../../language/English';

const FeedbackList = (props: { children: React.ReactNode; filterControls?: React.ReactNode }) => {
    return (
        <div className="container-fluid py-4">
            <div className="d-flex justify-content-between align-items-center mb-4 gap-2">
                <h3 className="text-darkblue fw-bold mb-0 feedback-list-title">{Language.FEEDBACKS || 'User Feedbacks'}</h3>
                {props.filterControls}
            </div>
            <div className="row g-4">
                {props.children}
            </div>
        </div>
    );
};

export default FeedbackList;
